import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFilter } from '@shared/interfaces/IFilter';
import { FilterService } from '@shared/services/filter.service';
import { IBase } from '@shared/interfaces';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    standalone: false
})
export class SearchBarComponent {
    @Input() value: string;
    @Input() placeholder: string;
    @Input() button: { placeholder: string };
    @Output() buttonClicked = new EventEmitter();
    @Output() valueChange = new EventEmitter();
    @Output() changeFilter = new EventEmitter<IFilter | string>();
    @Input() filters: Array<IFilter | IFilter[]>;

    constructor(public filterService: FilterService) {}

    @Input() set data(val: IBase[]) {
        this.filterService.data = val;
        if (val) {
            this.filterService.applyFilter();
        }

        if (this.value) {
            this.filterByText(this.value);
        }
    }

    get data(): IBase[] {
        return this.filterService.data;
    }

    filterByText(value: string) {
        this.filterService.applyTextFilter(value);
    }

    applyFilter(event: IFilter) {
        if ((event?.searchFor || event?.groupBy) && !event?.sortBy) {
            this.filterService.applyFilter(event);
        } else {
            this.changeFilter.emit(event);
        }
    }
}
